module.exports = __webpack_public_path__ + "static/img/nav5.46e5b0a7.svg";